import { LanguageLevel } from '../../../common/Languages';

/**
 * @typedef {string} LanguageProficienciesLevel - proficiencies from languages.json copies, ex "level_0"
 *
 * "proficiencies": {
    "level_0": "Unspecified",
    "level_1": "Basic",
    "level_2": "Conversational",
    "level_3": "Fluent",
    "level_4": "Native/Bilingual"
} */

/** @type {Record<keyof typeof LanguageLevel, LanguageProficienciesLevel>} */
const LanguageLevelMap = {
    [LanguageLevel.BASIC]: 'level_1',
    [LanguageLevel.CONVERSATIONAL]: 'level_2',
    [LanguageLevel.FLUENT]: 'level_3',
    [LanguageLevel.NATIVE_OR_BILINGUAL]: 'level_4',
};

/**
 * @type {(languageLevel: import('../../../../types').Language['level']) => LanguageProficienciesLevel}
 */
export const getLanguageCodeLevelKey = (languageLevel) =>
    LanguageLevelMap[languageLevel] ? `languages.proficiencies.${LanguageLevelMap[languageLevel]}` : '';
